import React from "react";

export default function BulkActionBar({
    selectedCount,
    onManageFeatures,
    onClearSelection,
}) {
    if (selectedCount === 0) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-40 bg-gray-800 border-t border-gray-600 shadow-lg">
            <div className="container mx-auto px-6 py-3 flex items-center justify-between">
                <div className="flex items-center space-x-4">
                    <span className="text-white font-medium">
                        {selectedCount} clinic{selectedCount > 1 ? 's' : ''} selected
                    </span>
                </div>
                <div className="flex items-center space-x-3">
                    <button
                        onClick={onManageFeatures}
                        className="px-4 py-2 bg-accent-1 hover:bg-accent-700 text-white rounded font-medium transition-colors"
                    >
                        Manage Features
                    </button>
                    <button
                        onClick={onClearSelection}
                        className="px-4 py-2 bg-gray-600 hover:bg-gray-500 text-white rounded font-medium transition-colors"
                    >
                        Clear
                    </button>
                </div>
            </div>
        </div>
    );
}
